<!--
    描述： 搜索查询共用组件
    时间： 2020-03-16
    created by ws
-->
<template>
	<div class="search-area-layout">
		<el-input :placeholder="'请输入' + placeholderName"
				  @input="doInput(sname, searchName)"
				  @keyup.enter.native="doSearch"
				  clearable
				  v-model="sname">
			<el-button slot="append"
					   type="primary"
					   size="small"
					   @click="doSearch"
					   icon="el-icon-search"></el-button>
		</el-input>
		<el-button v-if="showMore"
				   class="ml10"
				   :icon="isSearchMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
				   title="点击展示更多筛选条件"
				   size="small"
				   @click.native="handleMore"></el-button>
		<el-button v-if="showRefresh"
				   class="ml10"
				   type="warning"
				   icon="el-icon-refresh"
				   title="点击刷新数据"
				   size="small"
				   @click.native="handleRefresh"></el-button>
		<el-button v-if="showFilter"
				   class="ml10"
				   type="primary"
				   icon="el-icon-setting"
				   title="点击展示/隐藏筛选条件"
				   size="small"
				   @click.native="handleFilter"></el-button>
		<!-- 更多搜索盒子 -->
		<div class="more-layout"
			 v-show="isSearchMore"
			 ref="myPanel"
			 @click.stop>
			<!-- 具体筛选条件 -->
			<slot name="searchform" />
			<div class="footer text-center">
				<el-button type="warning"
						   size="small"
						   @click="doReset">重置</el-button>
				<el-button type="success"
						   size="small"
						   @click="doSearch">确定</el-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'searcharea',
	props: {
		// 是否展示更多筛选
		showMore: {
			type: Boolean,
			default: true
		},
		// 是否展示刷新重置按钮
		showRefresh: {
			type: Boolean,
			default: true
		},
		// 输入框所绑定的字段
		searchName: {
			type: String,
			default: ''
		},
		// 输入框提示文字
		placeholderName: {
			type: String,
			default: ''
		},
		// 是否展示筛选条件
		showFilter: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isSearchMore: false,
			sname: ''
		}
	},
	mounted() {
		// this.globalClick(this.hideContainer)
	},
	methods: {
		// 展示更多筛选
		handleMore(e) {
			this.isSearchMore = !this.isSearchMore
		},

		// 点击刷新
		handleRefresh() {
			this.sname = ''
			this.$emit('on-refresh')
		},

		// 点击 展示/隐藏 筛选
		handleFilter() {
			this.$emit('on-filter')
		},

		// 点击搜索区域以外的地方关闭搜索条件框
		hideContainer(e) {
			if (this.$refs.myPanel) {
				if (
					!this.$refs.myPanel.contains(e.target) &&
					e.target.id != 'moreBtn' &&
					e.target.className.indexOf('el-icon') != 0
				) {
					this.isSearchMore = false
				}
			}
		},
		// 输入框输入事件
		doInput(val, attr) {
			this.$emit('input', val, attr)
		},
		// 搜索操作
		doSearch() {
			this.$emit('on-search')
			this.isSearchMore = false
		},
		// 重置筛选条件
		doReset() {
			this.sname = ''
			this.$emit('on-reset')
		}
	}
}
</script>

<style lang="less">
.search-area-layout {
	@mainHeight: 32px;
	display: flex;
	align-items: center;
	position: relative;
	.el-input {
		width: 300px;
	}
	.el-input__inner {
		height: @mainHeight;
		line-height: @mainHeight;
	}
	.el-input-group__append {
		color: #fff;
		background-color: #008080;
	}
	& > .el-button {
		height: 32px;
	}
	.more-layout {
		position: absolute;
		top: 45px;
		right: 10px;
		min-width: 300px;
		background: #fff;
		padding: 5px 10px 10px;
		box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.15);
		border: 1px solid #e0e0e0;
		z-index: 1;
		@lineHeight: 34px;
		.el-form-item {
			margin-bottom: 5px;
		}
		.el-form-item__label {
			font-size: 12px;
			height: @lineHeight;
			line-height: @lineHeight;
		}
		.el-form-item__content {
			line-height: @lineHeight;
		}
		.el-input__icon {
			line-height: @lineHeight;
		}
		.el-input {
			width: 100%;
		}
		.footer {
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.el-input__clear {
		line-height: 34px;
	}
}
</style>


